<template>
    <section 
        class="o-path-panel-otg-mobile"
        :style="componentStyles"
    >
        <template v-if="!isPathInvalid">
            <div class="path-panel-step-wrapper">
                <component
                    v-if="step"
                    :is="stepComponent"
                    :step="step"
                    :index="activeStepIndex"
                    :steps="activePathSteps"
                    :isOutdoorItem="isOutdoorItem"
                    :activePathLength="activePathLength"
                    :destinationObject="destinationObject"
                />
            </div>
            <div class="path-panel-otg-footer">
                <AButtonOtg
                    :title="$t('ui.previous')"
                    :disabled="isPreviousStepDisabled"
                    @onClick="onPrevStep"
                />
                <div 
                    class="path-panel-otg-dispance"
                    v-if="!componentParams.is_show_indicator"
                >
                    <div class="step-distance">{{step && step.distance}} M</div>
                    <div class="total-distance">{{previousStepDistanece}}/{{totalDistance}} M</div>
                </div>
                <span 
                    v-else
                    class="path-panel-otg-indicator"
                >
                    {{ stepIndicator }} / {{ amountSteps }}
                </span>
                <AButtonOtg
                    :title="$t('ui.next')"
                    :disabled="isNextStepDisabled"
                    @onClick="onNextStep"
                />
            </div>
        </template>
        <span
            v-else
            class="path-otg-steps-error"
        >
            {{ invalidPathMessage }}
        </span>
    </section>
</template>

<script>
import {
    mapState,
    mapGetters
} from "vuex";

import AButtonOtg from '../../atoms/a-button-otg';
import OPathStepOtg from '../../organisms/o-path-step-otg';
import OPathStepDescription from '../../organisms/o-path-step-description';

import { MAP_SHOW_PATH_STEPS } from "@/shared/components/map-viewer/constants/map-events";

export default {
    name: 'OPathPanelOtgMobile',
    components: {
        AButtonOtg,
        OPathStepOtg,
        OPathStepDescription
    },
    props: {
        isPathInvalid: {
            type: Boolean,
            default: false
        },
        invalidPathMessage: {
            type: String,
            default: ''
        },
        isOutdoorItem: {
            type: Boolean,
            default: false
        },
        gMapsPosition: {
            type: Object,
            default: () => ({
                lat: '',
                lng: ''
            })
        },
        destinationObject: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapState({
            activePath: state => state.activePath,
            activeStepIndex: state => state.activeStepIndex,
            activePathLength: state => state.activePath?.steps.length
        }),
        ...mapGetters([
            'getMapConfigProp'
        ]),
        stepIndex() {
            return this.activeStepIndex === null ? 0 : this.activeStepIndex;
        },
        activePathSteps(){
            return this.activePath?.steps || [];
        },
        amountSteps() {
            return this.activePathSteps.length;
        },
        step() {
            return this.activePathSteps.length ? this.activePathSteps[this.stepIndex] : null;
        },
        stepIndicator() {
            return this.stepIndex + 1;
        },
        isNextStepDisabled() {
            return this.activePathSteps.length === this.stepIndex + 1 && !this.isOutdoorItem;
        },
        isPreviousStepDisabled() {
            return this.stepIndex === 0;
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPathPanelOtgMobile.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.footer.OPathPanelOtgMobile.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPathPanelOtgMobile.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.footer.OPathPanelOtgMobile.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        previousStepDistanece() {
            return this.activePathSteps.length && this.activePathSteps
                .filter((el, i) => i < this.activeStepIndex)
                .reduce((acc, {distance}) => acc + distance, 0)
        },
        totalDistance() {
            return this.activePathSteps.length && this.activePathSteps.reduce((acc, {distance}) => acc + distance, 0)
        },
        stepComponent() {
            return this.componentParams.step_component || 'OPathStepDescription'
        }
    },
    methods: {
        onPrevStep() {
            if (this.stepIndex === 0) return;

            this.$store.commit('setActiveStepIndex', this.stepIndex - 1);
            this.$bus.$emit(MAP_SHOW_PATH_STEPS, this.stepIndex - 1);
        },
        onNextStep() {
            const isOutdoorStep = (this.activePathSteps.length === this.stepIndex + 1) && this.isOutdoorItem;

            if (isOutdoorStep) {
                window.location = `https://www.google.com/maps/dir/Current+Location/${this.gMapsPosition.lat},${this.gMapsPosition.lng}`;
            }

            if (this.activePathSteps.length === this.stepIndex + 1) return;

            this.$store.commit('setActiveStepIndex', this.stepIndex + 1);
            this.$bus.$emit(MAP_SHOW_PATH_STEPS, this.stepIndex + 1);
        }
    }
}
</script>

<style lang="scss" src="./themes.scss" />